export type ImageMood = {
  background: string;
  blob1: string;
  blob2: string;
};

export type GalleryImage = {
  src: string;
  alt: string;
  ratio: number;
  dominantHex: string;
  mood?: ImageMood;
};

export type PortfolioStats = {
  events?: string[];
  schools?: string[];
  since?: string;
  season?: string;
};

export type Portfolio = {
  slug: string;
  discipline?: string;
  title: string;
  description: string;
  coverImage: string;
  stats?: PortfolioStats;
  images: GalleryImage[];
};

const portfolioModules = import.meta.glob<{ default: Portfolio }>(
  "../content/portfolios/*.json",
  { eager: true }
);

export const portfolios: Portfolio[] = Object.values(portfolioModules)
  .map((m) => m.default)
  .sort((a, b) => a.title.localeCompare(b.title));

export function getPortfolio(slug: string): Portfolio | undefined {
  return portfolios.find((p) => p.slug === slug);
}

export function getPortfoliosByDiscipline(disciplineSlug: string): Portfolio[] {
  return portfolios.filter((p) => p.discipline === disciplineSlug);
}

export function getAllImages(): GalleryImage[] {
  return portfolios.flatMap((p) => p.images);
}
